// reducers.js
const initialState = {
    activeTabIndex: 0,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_ACTIVE_TAB_INDEX":
            return { ...state, activeTabIndex: action.payload };
        default:
            return state;
    }
};

export default reducer;
